import { AsyncCrudDataGrid } from "src/components/common/dataGrid/crud/AsyncCrudDataGrid.tsx";
import { ReclamationCause } from "src/api/generated/erp/db/types/tables/reclamationCause.ts";
import { integerColumn, textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { dataGridPersistentStateProps } from "src/components/common/dataGrid/dataGridStateStorage.ts";
import { ReclamationCauseDataGridApi } from "src/api/generated/erp/reclamations/api/reclamationCauseDataGridApi";

export const ReclamationCausesDataGrid = () => {
	return (
		<AsyncCrudDataGrid<ReclamationCause>
			fetchData={ReclamationCauseDataGridApi.getAll}
			getRowId={(row) => row.reclamationCauseId}
			columns={[
				textColumn({
					field: "name",
					headerName: i18n.t("name"),
					editable: true,
					validate: "required",
					minWidth: 300
				}),
				integerColumn({
					field: "reclamationCauseId",
					headerName: i18n.t("id"),
				}),
			]}
			add={{
				type: "enabled",
				action: async () => {
					return {
						name: "",
					};
				},
			}}
			save={{
				type: "enabled",
				action: async (params) => {
					return await ReclamationCauseDataGridApi.save({
						reclamationCauses: params.items,
					});
				},
			}}
			remove={{
				type: "enabled",
				action: async (params) => {
					await ReclamationCauseDataGridApi.delete_({
						reclamationCauses: params.items,
					});
				},
			}}
			{...dataGridPersistentStateProps("F058C3B137B006E6")}
		/>
	);
};
